export const Marquee = () => {
  const words = [
    "Détente",
    "Respiration",
    "Sommeil profond",
    "Déconnexion",
    "Sérénité",
    "Rituels du soir",
    "Lâcher-prise",
  ];
  const line = [...words, ...words];

  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-white/5 py-8"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {line.map((w, i) => (
          <span
            key={i}
            className="mx-8 inline-flex items-center gap-8 text-3xl font-light uppercase tracking-[0.15em] text-white/25 sm:text-4xl"
          >
            {w}
            <span className="text-[#c9a84c]/50">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
